module.exports = __webpack_public_path__ + "img/imgZXGH(1).24554bd2.png";